import { render } from "./AddContactModal.vue?vue&type=template&id=07614d28"
import script from "./AddContactModal.vue?vue&type=script&lang=js"
export * from "./AddContactModal.vue?vue&type=script&lang=js"
script.render = render

export default script